import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  modalHeader: {
    backgroundColor: theme.palette.secondary.main
  },
  input: {
    BackgroundColor: theme.palette.background.paper,
    '&  .MuiFormHelperText-root.Mui-error': {
      BackgroundColor: theme.palette.background.paper,
      Margin: 0,
      PaddingLeft: 10,
      paddingBottom: 5,
      fontSize: 15
    }
  },
  content: {
    backgroundColor: 'rgba(0, 0, 0, 0.03)'
  },
  popover: {
    pointerEvents: 'none'
  },
  paper: {
    padding: theme.spacing(1),
    maxWidth: 600
  },
  borderHover: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: '6px',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    '&:hover': {
      borderColor: 'black'
    },
    '&:focus-within': {
      borderColor: 'transparent',
      boxShadow: '0 0 0 2px black'
    }
  },
  border: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: '6px',
    borderColor: 'rgba(0, 0, 0, 0.23)'
  },
  uploadInput: {
    display: 'none'
  },

  error: {
    color: 'red',
    marginRight: '20px',
    backgroundColor: 'white',
    padding: '10px',
    boxShadow: '0 10px 6px -6px #777'
  },
  error2: {
    color: 'red'
  },
  cost: {
    color: 'white',
    marginRight: '20px',
    padding: '10px'
  },
  disabledInput: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    cursor: 'not-allowed'
  },
  disabledOutline: {
    borderColor: 'rgba(0, 0, 0, 0.12) !important'
  },
  disabledLabel: {
    color: 'rgba(0, 0, 0, 0.38) !important'
  }

}));

export default useStyles
